import { endpoints } from '../../Constants';
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const paymentTermsServices = {
	getPaymentTerms,
};

/**
 * Fetch payment terms for a client.
 * Used for Vendor PO (orderType=1) when clientId === 5.
 * Pass any params the BE needs (e.g. { clientId }).
 */
function getPaymentTerms(params = {}) {
	const url = toQueryStringURL(endpoints.PAYMENT_TERMS, params);
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

export default paymentTermsServices;
